<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Walk-in Customer Service</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Walk-in Customer Property Update Service" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarValuation/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Walk-in Customer Service</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('valuation-dashboard')">Valuation Roll</a></li>
                    <li class="breadcrumb-item active">Walk-in Service</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Service Steps Progress -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="progress-steps">
                    <div class="step" :class="{ active: currentStep >= 1, completed: currentStep > 1 }">
                      <span class="step-number">1</span>
                      <span class="step-label">Find Property</span>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 2, completed: currentStep > 2 }">
                      <span class="step-number">2</span>
                      <span class="step-label">Verify Customer</span>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 3, completed: currentStep > 3 }">
                      <span class="step-number">3</span>
                      <span class="step-label">Update Details</span>
                    </div>
                    <div class="step" :class="{ active: currentStep >= 4 }">
                      <span class="step-number">4</span>
                      <span class="step-label">Submit Request</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 1: Property Search -->
          <div v-if="currentStep === 1" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header text-white">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-search me-2"></i>
                    Step 1: Find Customer's Property
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="search-section">
                        <div class="form-group mb-3">
                          <label class="form-label">LR Number *</label>
                          <div class="input-group input-group-lg">
                            <input
                                v-model="searchForm.lrNumber"
                                class="form-control"
                                type="text"
                                placeholder="e.g., KERICHO/KAPSOROK/1909"
                                @keyup.enter="searchProperty"
                                :disabled="loading"
                            >
                            <button @click="searchProperty" class="btn btn-primary" :disabled="loading || !searchForm.lrNumber.trim()">
                              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                              <i v-else class="bx bx-search me-2"></i>
                              {{loading ? 'Searching...' : 'Search'}}
                            </button>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="form-label">Owner Name (Optional)</label>
                          <input
                              v-model="searchForm.ownerName"
                              class="form-control"
                              type="text"
                              placeholder="Enter owner name for verification"
                              :disabled="loading"
                          >
                          <small class="text-muted">This helps verify we're finding the correct property</small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="help-card bg-light p-3 rounded">
                        <h6 class="text-primary">
                          <i class="bx bx-info-circle me-2"></i>
                          Quick Tips
                        </h6>
                        <ul class="small mb-0">
                          <li>Ask customer for their title deed or previous land rates receipt</li>
                          <li>LR Number format: COUNTY/LOCATION/NUMBER</li>
                          <li>Include all forward slashes (/) as shown on documents</li>
                          <li>Double-check spelling and numbers</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Search Results -->
                  <div v-if="searchResults.length > 0" class="search-results mt-4">
                    <h6 class="mb-3">Search Results:</h6>
                    <div v-for="property in searchResults" :key="property.id" class="property-result-card mb-3">
                      <div class="card border-primary">
                        <div class="card-body">
                          <div class="row align-items-center">
                            <div class="col-md-8">
                              <h6 class="card-title text-primary mb-2">{{property.LRNumber}}</h6>
                              <div class="row">
                                <div class="col-md-6">
                                  <p class="mb-1"><strong>Owner:</strong> {{property.ownerNames}}</p>
                                  <p class="mb-1"><strong>Phone:</strong> {{property.ownerPhoneNo || 'Not available'}}</p>
                                  <p class="mb-1"><strong>Location:</strong> {{property.percelAddress}}</p>
                                </div>
                                <div class="col-md-6">
                                  <p class="mb-1"><strong>Sub-County:</strong> {{property.subCountyName}}</p>
                                  <p class="mb-1"><strong>Ward:</strong> {{property.wardName}}</p>
                                  <p class="mb-1"><strong>Size:</strong> {{property.percelSize}} Ha</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4 text-end">
                              <button @click="selectProperty(property)" class="btn btn-lg" style="background: #286424; color: white">
                                <i class="bx bx-check me-2"></i>
                                Select This Property
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- No Results -->
                  <div v-if="showNoResults" class="no-results mt-4">
                    <div class="alert alert-warning">
                      <h6><i class="bx bx-exclamation-triangle me-2"></i>Property Not Found</h6>
                      <p class="mb-2">We couldn't find a property with LR Number: <strong>{{searchForm.lrNumber}}</strong></p>
                      <p class="mb-0">Please:</p>
                      <ul class="mb-0 mt-2">
                        <li>Double-check the LR Number with the customer</li>
                        <li>Ensure all forward slashes (/) are included</li>
                        <li>Verify the spelling and format</li>
                        <li>Contact supervisor if the property should exist</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Customer Verification -->
          <div v-if="currentStep === 2" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header text-white">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-shield-alt me-2"></i>
                    Step 2: Verify Customer Identity
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <!-- Selected Property Info -->
                      <div class="selected-property-info mb-4">
                        <h6 class="text-primary mb-3">Selected Property Information</h6>
                        <div class="card bg-light">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-6">
                                <p class="mb-2"><strong>LR Number:</strong><br>{{selectedProperty.LRNumber}}</p>
                                <p class="mb-2"><strong>Owner:</strong><br>{{selectedProperty.ownerNames}}</p>
                                <p class="mb-0"><strong>Location:</strong><br>{{selectedProperty.percelAddress}}</p>
                              </div>
                              <div class="col-6">
                                <p class="mb-2"><strong>Sub-County:</strong><br>{{selectedProperty.subCountyName}}</p>
                                <p class="mb-2"><strong>Ward:</strong><br>{{selectedProperty.wardName}}</p>
                                <p class="mb-0"><strong>Size:</strong><br>{{selectedProperty.percelSize}} Ha</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <!-- Customer Verification Form -->
                      <div class="verification-form">
                        <h6 class="text-info mb-3">Customer Verification Details</h6>

                        <div class="form-group mb-3">
                          <label class="form-label">Full Name *</label>
                          <input
                              v-model="verificationForm.fullName"
                              class="form-control"
                              type="text"
                              placeholder="Customer's full name as on ID"
                              required
                          >
                          <small class="text-muted">Must match name on identification document</small>
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label">ID/Passport Number *</label>
                          <input
                              v-model="verificationForm.idNumber"
                              class="form-control"
                              type="text"
                              placeholder="ID or Passport number"
                              required
                          >
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label">Phone Number *</label>
                          <input
                              v-model="verificationForm.phoneNumber"
                              class="form-control"
                              type="tel"
                              placeholder="0700000000"
                              required
                          >
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label">Email Address (Optional)</label>
                          <input
                              v-model="verificationForm.email"
                              class="form-control"
                              type="email"
                              placeholder="customer@example.com"
                          >
                        </div>

                        <div class="form-group mb-3">
                          <label class="form-label">Relationship to Property *</label>
                          <select v-model="verificationForm.relationship" class="form-control" required>
                            <option value="">Select relationship</option>
                            <option value="owner">Property Owner</option>
                            <option value="co-owner">Co-owner</option>
                            <option value="authorized-representative">Authorized Representative</option>
                            <option value="family-member">Family Member</option>
                            <option value="legal-guardian">Legal Guardian</option>
                            <option value="power-of-attorney">Power of Attorney</option>
                          </select>
                        </div>

                        <div v-if="verificationForm.relationship && verificationForm.relationship !== 'owner'" class="form-group mb-3">
                          <label class="form-label">Authorization Details *</label>
                          <textarea
                              v-model="verificationForm.authorizationDetails"
                              class="form-control"
                              rows="3"
                              placeholder="Explain the authorization (e.g., power of attorney, family relationship, etc.)"
                              required
                          ></textarea>
                        </div>

                        <div class="verification-actions">
                          <button @click="currentStep = 1" class="btn btn-outline-secondary me-2">
                            <i class="bx bx-arrow-back me-2"></i>Back
                          </button>
                          <button @click="verifyCustomer" class="btn btn-primary" :disabled="!isVerificationValid">
                            <i class="bx bx-shield-check me-2"></i>Verify & Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Update Form -->
          <div v-if="currentStep === 3" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header text-white">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-edit me-2"></i>
                    Step 3: Property Update Details
                  </h5>
                </div>
                <div class="card-body">
                  <!-- Current Property Summary -->
                  <div class="current-property-summary mb-4">
                    <h6 class="text-success mb-3">Current Property Information</h6>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="card bg-light">
                          <div class="card-body">
                            <h6 class="card-title">Property Details</h6>
                            <p class="mb-1"><strong>LR:</strong> {{selectedProperty.LRNumber}}</p>
                            <p class="mb-1"><strong>Owner:</strong> {{selectedProperty.ownerNames}}</p>
                            <p class="mb-1"><strong>Phone:</strong> {{selectedProperty.ownerPhoneNo || 'Not provided'}}</p>
                            <p class="mb-0"><strong>Email:</strong> {{selectedProperty.ownerEmail || 'Not provided'}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card bg-light">
                          <div class="card-body">
                            <h6 class="card-title">Location Information</h6>
                            <p class="mb-1"><strong>Address:</strong> {{selectedProperty.percelAddress}}</p>
                            <p class="mb-1"><strong>Sub-County:</strong> {{selectedProperty.subCountyName}}</p>
                            <p class="mb-1"><strong>Ward:</strong> {{selectedProperty.wardName}}</p>
                            <p class="mb-0"><strong>Size:</strong> {{selectedProperty.percelSize}} Ha</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card bg-light">
                          <div class="card-body">
                            <h6 class="card-title">Financial Information</h6>
                            <p class="mb-1"><strong>Annual Charges:</strong> {{formatPrice(selectedProperty.annualCharges)}}</p>
                            <p class="mb-1"><strong>Outstanding:</strong> <span class="text-danger">{{formatPrice(selectedProperty.outstandingArrears)}}</span></p>
                            <p class="mb-0"><strong>Status:</strong> <span class="badge bg-success">{{selectedProperty.status}}</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Update Types Selection -->
                  <div class="update-types-section mb-4">
                    <h6 class="text-primary mb-3">What needs to be updated?</h6>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-check mb-3">
                          <input v-model="updateTypes.ownerInfo" class="form-check-input" type="checkbox" id="updateOwner">
                          <label class="form-check-label" for="updateOwner">
                            <strong>Owner Information</strong><br>
                            <small class="text-muted">Name, contact details, ID number</small>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check mb-3">
                          <input v-model="updateTypes.propertyDetails" class="form-check-input" type="checkbox" id="updateProperty">
                          <label class="form-check-label" for="updateProperty">
                            <strong>Property Details</strong><br>
                            <small class="text-muted">Address, use, improvements</small>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check mb-3">
                          <input v-model="updateTypes.ownershipTransfer" class="form-check-input" type="checkbox" id="updateOwnership">
                          <label class="form-check-label" for="updateOwnership">
                            <strong>Ownership Transfer</strong><br>
                            <small class="text-muted">Change of ownership details</small>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-check mb-3">
                          <input v-model="updateTypes.propertyImprovements" class="form-check-input" type="checkbox" id="updateImprovements">
                          <label class="form-check-label" for="updateImprovements">
                            <strong>Property Improvements</strong><br>
                            <small class="text-muted">New buildings, structures, developments</small>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Update Forms Based on Selection -->
                  <div v-if="hasSelectedUpdates">
                    <!-- Owner Information Update -->
                    <div v-if="updateTypes.ownerInfo" class="update-section mb-4">
                      <h6 class="text-info mb-3">Owner Information Updates</h6>
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Full Name</label>
                                <input v-model="updateForm.ownerNames" class="form-control" type="text" :placeholder="selectedProperty.ownerNames">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">ID/Passport Number</label>
                                <input v-model="updateForm.ownerID" class="form-control" type="text" :placeholder="selectedProperty.ownerID || 'Enter ID number'">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Phone Number</label>
                                <input v-model="updateForm.ownerPhoneNo" class="form-control" type="tel" :placeholder="selectedProperty.ownerPhoneNo || '0700000000'">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Email Address</label>
                                <input v-model="updateForm.ownerEmail" class="form-control" type="email" :placeholder="selectedProperty.ownerEmail || 'email@example.com'">
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Physical Address</label>
                            <textarea v-model="updateForm.physicalAddress" class="form-control" rows="2" :placeholder="selectedProperty.physicalAddress || 'Enter physical address'"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Property Details Update -->
                    <div v-if="updateTypes.propertyDetails" class="update-section mb-4">
                      <h6 class="text-info mb-3">Property Details Updates</h6>
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-8">
                              <div class="form-group mb-3">
                                <label class="form-label">Property Address/Location</label>
                                <input v-model="updateForm.percelAddress" class="form-control" type="text" :placeholder="selectedProperty.percelAddress">
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label class="form-label">Property Use</label>
                                <select v-model="updateForm.useName" class="form-control">
                                  <option value="">Select use type</option>
                                  <option value="Residential">Residential</option>
                                  <option value="Commercial">Commercial</option>
                                  <option value="Industrial">Industrial</option>
                                  <option value="Agricultural">Agricultural</option>
                                  <option value="Mixed-Use">Mixed-Use</option>
                                  <option value="Institutional">Institutional</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Ownership Transfer -->
                    <div v-if="updateTypes.ownershipTransfer" class="update-section mb-4">
                      <h6 class="text-warning mb-3">Ownership Transfer Details</h6>
                      <div class="card border-warning">
                        <div class="card-body">
                          <div class="alert alert-warning">
                            <i class="bx bx-exclamation-triangle me-2"></i>
                            <strong>Important:</strong> Ownership transfers require additional documentation and verification.
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">New Owner Name *</label>
                                <input v-model="updateForm.newOwnerName" class="form-control" type="text" placeholder="Enter new owner's full name" required>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">New Owner ID Number *</label>
                                <input v-model="updateForm.newOwnerID" class="form-control" type="text" placeholder="Enter new owner's ID number" required>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Transfer Date *</label>
                                <input v-model="updateForm.transferDate" class="form-control" type="date" required>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Transfer Type</label>
                                <select v-model="updateForm.transferType" class="form-control">
                                  <option value="">Select transfer type</option>
                                  <option value="Sale">Sale</option>
                                  <option value="Gift">Gift</option>
                                  <option value="Inheritance">Inheritance</option>
                                  <option value="Court Order">Court Order</option>
                                  <option value="Other">Other</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Property Improvements -->
                    <div v-if="updateTypes.propertyImprovements" class="update-section mb-4">
                      <h6 class="text-primary mb-3">Property Improvements</h6>
                      <div class="card">
                        <div class="card-body">
                          <div class="form-group mb-3">
                            <label class="form-label">Describe the improvements made to the property</label>
                            <textarea v-model="updateForm.improvements" class="form-control" rows="4" placeholder="Describe any new buildings, structures, renovations, or developments"></textarea>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Approximate Cost of Improvements</label>
                                <input v-model="updateForm.improvementCost" class="form-control" type="number" placeholder="Enter amount in KES">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-3">
                                <label class="form-label">Completion Date</label>
                                <input v-model="updateForm.improvementDate" class="form-control" type="date">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Additional Notes -->
                    <div class="notes-section mb-4">
                      <h6 class="text-secondary mb-3">Additional Information</h6>
                      <div class="form-group">
                        <label class="form-label">Additional Notes or Comments</label>
                        <textarea v-model="updateForm.notes" class="form-control" rows="3" placeholder="Any additional information about this update request"></textarea>
                      </div>
                    </div>

                    <!-- Navigation Actions -->
                    <div class="step-actions">
                      <button @click="currentStep = 2" class="btn btn-outline-secondary me-2">
                        <i class="bx bx-arrow-back me-2"></i>Back
                      </button>
                      <button @click="reviewRequest" class="btn btn-primary">
                        <i class="bx bx-check me-2"></i>Review & Submit
                      </button>
                    </div>
                  </div>
                  <div v-else class="text-center py-4">
                    <i class="bx bx-info-circle text-muted" style="font-size: 3rem;"></i>
                    <h6 class="text-muted mt-2">Please select at least one update type above</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 4: Review and Submit -->
          <div v-if="currentStep === 4" class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header text-dark">
                  <h5 class="card-title mb-0">
                    <i class="bx bx-check-circle me-2"></i>
                    Step 4: Review and Submit Request
                  </h5>
                </div>
                <div class="card-body">
                  <!-- Request Summary -->
                  <div class="request-summary">
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <h6 class="text-primary mb-3">Property Information</h6>
                        <div class="card bg-light">
                          <div class="card-body">
                            <p class="mb-2"><strong>LR Number:</strong> {{selectedProperty.LRNumber}}</p>
                            <p class="mb-2"><strong>Current Owner:</strong> {{selectedProperty.ownerNames}}</p>
                            <p class="mb-2"><strong>Location:</strong> {{selectedProperty.percelAddress}}</p>
                            <p class="mb-0"><strong>Sub-County:</strong> {{selectedProperty.subCountyName}}, <strong>Ward:</strong> {{selectedProperty.wardName}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <h6 class="text-info mb-3">Customer Information</h6>
                        <div class="card bg-light">
                          <div class="card-body">
                            <p class="mb-2"><strong>Name:</strong> {{verifiedCustomer.fullName}}</p>
                            <p class="mb-2"><strong>ID Number:</strong> {{verifiedCustomer.idNumber}}</p>
                            <p class="mb-2"><strong>Phone:</strong> {{verifiedCustomer.phoneNumber}}</p>
                            <p class="mb-0"><strong>Relationship:</strong> {{verifiedCustomer.relationship}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Update Summary -->
                    <div class="update-summary mb-4">
                      <h6 class="text-success mb-3">Requested Updates</h6>
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <div v-if="updateTypes.ownerInfo" class="update-item mb-3">
                                <div class="d-flex align-items-center mb-2">
                                  <i class="bx bx-user text-info me-2"></i>
                                  <strong>Owner Information Update</strong>
                                </div>
                                <div class="ms-4">
                                  <p v-if="updateForm.ownerNames" class="mb-1"><small>Name: {{updateForm.ownerNames}}</small></p>
                                  <p v-if="updateForm.ownerPhoneNo" class="mb-1"><small>Phone: {{updateForm.ownerPhoneNo}}</small></p>
                                  <p v-if="updateForm.ownerEmail" class="mb-1"><small>Email: {{updateForm.ownerEmail}}</small></p>
                                </div>
                              </div>

                              <div v-if="updateTypes.propertyDetails" class="update-item mb-3">
                                <div class="d-flex align-items-center mb-2">
                                  <i class="bx bx-home text-success me-2"></i>
                                  <strong>Property Details Update</strong>
                                </div>
                                <div class="ms-4">
                                  <p v-if="updateForm.percelAddress" class="mb-1"><small>Address: {{updateForm.percelAddress}}</small></p>
                                  <p v-if="updateForm.useName" class="mb-1"><small>Use: {{updateForm.useName}}</small></p>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div v-if="updateTypes.ownershipTransfer" class="update-item mb-3">
                                <div class="d-flex align-items-center mb-2">
                                  <i class="bx bx-exchange-alt text-warning me-2"></i>
                                  <strong>Ownership Transfer</strong>
                                </div>
                                <div class="ms-4">
                                  <p v-if="updateForm.newOwnerName" class="mb-1"><small>New Owner: {{updateForm.newOwnerName}}</small></p>
                                  <p v-if="updateForm.transferType" class="mb-1"><small>Type: {{updateForm.transferType}}</small></p>
                                  <p v-if="updateForm.transferDate" class="mb-1"><small>Date: {{formatDate(updateForm.transferDate)}}</small></p>
                                </div>
                              </div>

                              <div v-if="updateTypes.propertyImprovements" class="update-item mb-3">
                                <div class="d-flex align-items-center mb-2">
                                  <i class="bx bx-tools text-primary me-2"></i>
                                  <strong>Property Improvements</strong>
                                </div>
                                <div class="ms-4">
                                  <p v-if="updateForm.improvements" class="mb-1"><small>{{updateForm.improvements.substring(0, 100)}}{{updateForm.improvements.length > 100 ? '...' : ''}}</small></p>
                                  <p v-if="updateForm.improvementCost" class="mb-1"><small>Cost: {{formatPrice(updateForm.improvementCost)}}</small></p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-if="updateForm.notes" class="additional-notes mt-3 pt-3 border-top">
                            <strong>Additional Notes:</strong>
                            <p class="text-muted mb-0">{{updateForm.notes}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Reference Number Generation -->
                    <div class="reference-section mb-4">
                      <h6 class="text-warning mb-3">Request Reference</h6>
                      <div class="card border-warning">
                        <div class="card-body">
                          <div class="row align-items-center">
                            <div class="col-md-8">
                              <p class="mb-2"><strong>Reference Number:</strong></p>
                              <h5 class="text-primary mb-0">{{generatedReference || 'Will be generated upon submission'}}</h5>
                            </div>
                            <div class="col-md-4 text-end">
                              <button v-if="!generatedReference" @click="generateReference" class="btn btn-outline-warning">
                                <i class="bx bx-refresh me-2"></i>Generate Reference
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Admin Notes -->
                    <div class="admin-notes mb-4">
                      <h6 class="text-secondary mb-3">Administrative Notes</h6>
                      <div class="form-group">
                        <textarea v-model="adminNotes" class="form-control" rows="3" placeholder="Add any administrative notes about this request (optional)"></textarea>
                      </div>
                    </div>

                    <!-- Final Actions -->
                    <div class="final-actions">
                      <div class="row">
                        <div class="col-md-6">
                          <button @click="currentStep = 3" class="btn btn-outline-secondary btn-lg w-100">
                            <i class="bx bx-arrow-back me-2"></i>Back to Edit
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button @click="submitRequest" class="btn btn-success btn-lg w-100" :disabled="submitting || !generatedReference">
                            <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>
                            <i v-else class="bx bx-check-circle me-2"></i>
                            {{submitting ? 'Submitting...' : 'Submit Request'}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Success Modal -->
          <div v-if="showSuccessModal" class="modal show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header text-white">
                  <h5 class="modal-title">
                    <i class="bx bx-check-circle me-2"></i>
                    Request Submitted Successfully
                  </h5>
                </div>
                <div class="modal-body text-center">
                  <div class="success-icon mb-4">
                    <i class="bx bx-check-circle text-success" style="font-size: 4rem;"></i>
                  </div>
                  <h5 class="text-success mb-3">Property Update Request Created</h5>
                  <div class="alert alert-success">
                    <h6 class="mb-2">Reference Number:</h6>
                    <h4 class="text-primary mb-0">{{submissionResult.referenceNumber}}</h4>
                  </div>
                  <div class="customer-info bg-light p-3 rounded mb-3">
                    <p class="mb-2"><strong>Customer:</strong> {{verifiedCustomer.fullName}}</p>
                    <p class="mb-2"><strong>Property:</strong> {{selectedProperty.LRNumber}}</p>
                    <p class="mb-0"><strong>Status:</strong> <span class="badge bg-warning">Pending Review</span></p>
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="printReference" class="btn btn-outline-primary">
                    <i class="bx bx-printer me-2"></i>Print Reference
                  </button>
                  <button @click="startNewRequest" class="btn btn-success">
                    <i class="bx bx-plus me-2"></i>New Request
                  </button>
                  <button @click="viewRequest" class="btn btn-primary">
                    <i class="bx bx-eye me-2"></i>View Request
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Walk-in Customer Service System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight, landRate} from "@/api";
import moment from 'moment';
import ToolBarValuation from "@/components/valuation/ToolBar.vue";

export default {
  name: "ValuationWalkIn",
  components: {ToolBarValuation, NavigationBar},

  data() {
    return {
      loading: false,
      submitting: false,
      currentStep: 1,

      // Search form
      searchForm: {
        lrNumber: '',
        ownerName: ''
      },

      // Search results
      searchResults: [],
      showNoResults: false,
      selectedProperty: null,

      // Verification form
      verificationForm: {
        fullName: '',
        idNumber: '',
        phoneNumber: '',
        email: '',
        relationship: '',
        authorizationDetails: ''
      },
      verifiedCustomer: null,

      // Update types
      updateTypes: {
        ownerInfo: false,
        propertyDetails: false,
        ownershipTransfer: false,
        propertyImprovements: false
      },

      // Update form
      updateForm: {
        ownerNames: '',
        ownerID: '',
        ownerPhoneNo: '',
        ownerEmail: '',
        physicalAddress: '',
        percelAddress: '',
        useName: '',
        newOwnerName: '',
        newOwnerID: '',
        transferDate: '',
        transferType: '',
        improvements: '',
        improvementCost: '',
        improvementDate: '',
        notes: ''
      },

      // Admin and submission
      adminNotes: '',
      generatedReference: '',
      submissionResult: null,
      showSuccessModal: false
    }
  },

  computed: {
    hasSelectedUpdates() {
      return Object.values(this.updateTypes).some(Boolean);
    },

    isVerificationValid() {
      const { fullName, idNumber, phoneNumber, relationship } = this.verificationForm;
      const basicValid = fullName.trim() && idNumber.trim() && phoneNumber.trim() && relationship;

      if (relationship && relationship !== 'owner') {
        return basicValid && this.verificationForm.authorizationDetails.trim();
      }

      return basicValid;
    }
  },

  mounted() {
    this.menuAccess();

    // Check if there's a property from another page
    const walkInProperty = sessionStorage.getItem('walkInProperty');
    if (walkInProperty) {
      this.selectedProperty = JSON.parse(walkInProperty);
      sessionStorage.removeItem('walkInProperty');
      this.currentStep = 2;
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Walk-in Customer Service");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    searchProperty() {
      if (!this.searchForm.lrNumber.trim()) {
        alert('Please enter an LR Number');
        return;
      }

      this.loading = true;
      this.searchResults = [];
      this.showNoResults = false;

      const data = new FormData();
      data.append("function", "searchPropertyForUpdate");
      data.append("lrNumber", this.searchForm.lrNumber.trim());
      if (this.searchForm.ownerName.trim()) {
        data.append("ownerName", this.searchForm.ownerName.trim());
      }

      execute2(data, landRate)
          .then((res) => {
            if (res.data.success) {
              this.searchResults = Array.isArray(res.data.data.properties)
                  ? res.data.data.properties
                  : [res.data.data.property];
              this.showNoResults = false;
            } else {
              this.searchResults = [];
              this.showNoResults = true;
            }
          })
          .catch((e) => {
            console.error('Search error:', e);
            alert('Error searching for property. Please try again.');
            this.searchResults = [];
            this.showNoResults = true;
          })
          .finally(() => {
            this.loading = false;
          });
    },

    selectProperty(property) {
      this.selectedProperty = property;
      this.currentStep = 2;
    },

    verifyCustomer() {
      if (!this.isVerificationValid) {
        alert('Please fill in all required verification fields');
        return;
      }

      // Store verified customer info
      this.verifiedCustomer = { ...this.verificationForm };
      this.currentStep = 3;
    },

    reviewRequest() {
      if (!this.hasSelectedUpdates) {
        alert('Please select at least one update type');
        return;
      }

      this.currentStep = 4;
      if (!this.generatedReference) {
        this.generateReference();
      }
    },

    async generateReference() {
      try {
        const data = new FormData();
        data.append("function", "generateReferenceNumber");

        const response = await execute2(data, landRate);

        if (response.data.success) {
          this.generatedReference = response.data.data.referenceNumber;
        } else {
          // Fallback to frontend generation
          this.generatedReference = 'UPD-' + Date.now().toString(36).toUpperCase();
        }
      } catch (error) {
        console.error('Error generating reference:', error);
        // Fallback to frontend generation
        this.generatedReference = 'UPD-' + Date.now().toString(36).toUpperCase();
      }
    },

    async submitRequest() {
      if (!this.generatedReference) {
        alert('Please generate a reference number first');
        return;
      }

      this.submitting = true;

      try {
        const data = new FormData();
        data.append("function", "submitPropertyUpdate");
        data.append("propertyId", this.selectedProperty.id);
        data.append("lrNumber", this.selectedProperty.LRNumber);
        data.append("referenceNumber", this.generatedReference);
        data.append("updateTypes", JSON.stringify(this.updateTypes));
        data.append("currentData", JSON.stringify(this.selectedProperty));
        data.append("requestedData", JSON.stringify(this.updateForm));
        data.append("verifiedOwner", JSON.stringify(this.verifiedCustomer));

        const response = await execute2(data, landRate);

        if (response.data.success) {
          this.submissionResult = {
            referenceNumber: this.generatedReference,
            status: 'pending',
            submittedAt: new Date().toISOString()
          };
          this.showSuccessModal = true;
        } else {
          throw new Error(response.data.message || 'Failed to submit request');
        }

      } catch (error) {
        console.error('Submission error:', error);
        alert('Error submitting request: ' + error.message);
      } finally {
        this.submitting = false;
      }
    },

    printReference() {
      const printContent = `
        Property Update Request - Walk-in Service

        Reference Number: ${this.submissionResult.referenceNumber}
        Property LR Number: ${this.selectedProperty.LRNumber}
        Customer Name: ${this.verifiedCustomer.fullName}
        Customer Phone: ${this.verifiedCustomer.phoneNumber}
        Submission Date: ${moment().format('DD/MM/YYYY HH:mm')}
        Status: Pending Review

        Served by: ${sessionStorage.getItem("sessionNames")}
        Office: County Revenue Office

        Please keep this reference number for tracking your request.
        Contact: 0700-000-000 for inquiries.
      `;

      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Property Update Reference - ${this.submissionResult.referenceNumber}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; line-height: 1.6; }
              h1 { color: #2c3e50; }
              .reference { background: #f8f9fa; padding: 15px; border-left: 4px solid #007bff; }
            </style>
          </head>
          <body>
            <h1>County Revenue Office</h1>
            <div class="reference">
              <pre>${printContent}</pre>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    },

    startNewRequest() {
      // Reset all form data
      this.currentStep = 1;
      this.searchForm = { lrNumber: '', ownerName: '' };
      this.searchResults = [];
      this.showNoResults = false;
      this.selectedProperty = null;
      this.verificationForm = {
        fullName: '',
        idNumber: '',
        phoneNumber: '',
        email: '',
        relationship: '',
        authorizationDetails: ''
      };
      this.verifiedCustomer = null;
      this.updateTypes = {
        ownerInfo: false,
        propertyDetails: false,
        ownershipTransfer: false,
        propertyImprovements: false
      };
      this.updateForm = {
        ownerNames: '',
        ownerID: '',
        ownerPhoneNo: '',
        ownerEmail: '',
        physicalAddress: '',
        percelAddress: '',
        useName: '',
        newOwnerName: '',
        newOwnerID: '',
        transferDate: '',
        transferType: '',
        improvements: '',
        improvementCost: '',
        improvementDate: '',
        notes: ''
      };
      this.adminNotes = '';
      this.generatedReference = '';
      this.submissionResult = null;
      this.showSuccessModal = false;
    },

    viewRequest() {
      // Navigate to view the created request
      sessionStorage.setItem('viewRequestReference', this.submissionResult.referenceNumber);
      this.gotTo('valuation-requests');
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value || 0);
    },

    formatDate(dateString) {
      return moment(dateString).format('DD/MM/YYYY');
    },

    gotTo(route) {
      router.push(route);
    }
  },

  watch: {
    'searchForm.lrNumber'(newVal) {
      this.searchForm.lrNumber = newVal.toUpperCase();
      this.showNoResults = false;
    },
    'verificationForm.phoneNumber'(newVal) {
      this.verificationForm.phoneNumber = newVal.replace(/\D/g, '').substring(0, 10);
    },
    'verificationForm.idNumber'(newVal) {
      this.verificationForm.idNumber = newVal.toUpperCase();
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Progress Steps */
.progress-steps {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 0 50px;
}

.progress-steps::before {
  content: '';
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  height: 2px;
  background: #dee2e6;
  z-index: 1;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  background: white;
  padding: 0 15px;
}

.step-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  border: 2px solid #e9ecef;
}

.step.active .step-number {
  background: #007bff;
  color: white;
  border-color: #007bff;
  transform: scale(1.1);
}

.step.completed .step-number {
  background: #28a745;
  color: white;
  border-color: #28a745;
}

.step-label {
  font-size: 13px;
  text-align: center;
  color: #6c757d;
  font-weight: 500;
}

.step.active .step-label,
.step.completed .step-label {
  color: #495057;
  font-weight: 600;
}

/* Property Result Cards */
.property-result-card:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

/* Form Styling */
.form-check-label {
  cursor: pointer;
}

.form-check-input:checked + .form-check-label {
  color: #007bff;
}

/* Update Sections */
.update-section .card {
  border-left: 4px solid #007bff;
}

.update-item {
  padding: 10px;
  border-left: 3px solid #e9ecef;
  margin-bottom: 15px;
}

/* Modal Styling */
.modal.show {
  display: block !important;
}

.success-icon {
  animation: bounceIn 1s ease;
}

@keyframes bounceIn {
  0%, 20%, 40%, 60%, 80% {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }
  0% {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(.9, .9, .9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(.97, .97, .97);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .progress-steps {
    margin: 0 20px;
  }

  .step-number {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .step-label {
    font-size: 11px;
  }
}
</style>